"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Delete = _interopRequireDefault(require("@mui/icons-material/Delete"));
var _Text = _interopRequireDefault(require("../../../components/Text"));
var Theme = _interopRequireWildcard(require("../../../theme"));
var _system = require("@mui/system");
var _i18n = _interopRequireDefault(require("../../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../../localization/tokens"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var CardBlock = (0, _system.styled)("div")(function (_ref) {
  var theme = _ref.theme;
  return {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    alignItems: 'center',
    '&:hover': {
      borderLeft: "".concat(theme.palette.primary.main, " solid 5px")
    },
    backgroundColor: Theme.colors.surface,
    borderLeft: "".concat(Theme.colors.surface, " solid 5px"),
    boxShadow: '0 1px 2px rgba(0, 0, 0, .15)',
    cursor: 'pointer',
    height: 'auto',
    padding: 10,
    position: 'relative'
  };
});

/**
 * @param data
 * @param remove
 * @param edit
 * @param isAuthorityView
 * @param classes
 * @returns {*}
 * @constructor
 */
var ExistingCoverageBlock = function ExistingCoverageBlock(_ref2) {
  var data = _ref2.data,
    remove = _ref2.remove,
    edit = _ref2.edit,
    isAuthorityView = _ref2.isAuthorityView,
    classes = _ref2.classes;
  var styles = {
    cardRow: {
      display: 'flex',
      flex: 1,
      flexDirection: 'row'
    },
    btnGroup: {
      display: 'flex',
      flexDirection: 'row'
    },
    section: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column'
    }
  };
  return /*#__PURE__*/_react["default"].createElement(CardBlock, null, /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.cardRow,
    onClick: edit
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.section
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    tiny: true
  }, _i18n["default"].t(_tokens["default"].labels.masterApplication.nameOfInsurerCarrier)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true
  }, data.carrier)), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.section
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    tiny: true
  }, _i18n["default"].t(_tokens["default"].labels.masterApplication.benefitsCovered)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true
  }, data.benefits.join(', ')))), !isAuthorityView && /*#__PURE__*/_react["default"].createElement(_Delete["default"], {
    onClick: remove
  }));
};
var _default = exports["default"] = ExistingCoverageBlock;